import { trpc, type RouterInputs, type RouterOutputs } from '@klear/ui/lib/trpc'
import { reviewMode } from '@/app/document-review/review-mode'

export type DocumentReviewUpdateInput = RouterInputs['documentReview']['update']
export type DocumentReviewDetailOutput = RouterOutputs['documentReview']['get']
export type DocumentReviewProposalView = DocumentReviewDetailOutput['proposals'][number]
export type DocumentReviewDoubtView = DocumentReviewProposalView['doubts'][number]

const RUN_POLL_MS = 2500

export function useDocumentReviewDocument(documentKey: string, options: { poll?: boolean } = {}) {
  return trpc.documentReview.document.useQuery(
    { documentKey },
    {
      enabled: documentKey !== '',
      refetchOnWindowFocus: true,
      refetchOnMount: 'always',
      refetchInterval: (query) => (options.poll === true || query.state.data?.queued === true ? RUN_POLL_MS : false)
    }
  )
}

export function useDocumentReviewDetail(processingId: string, options: { poll?: boolean } = {}) {
  return trpc.documentReview.get.useQuery(
    { processingId },
    {
      enabled: processingId !== '',
      refetchOnWindowFocus: true,
      refetchOnMount: 'always',
      refetchInterval: (query) =>
        options.poll === true || (query.state.data !== undefined && reviewMode(query.state.data.step) === 'processing')
          ? RUN_POLL_MS
          : false
    }
  )
}
